/**
 * Subsequence match, case and whitespace insensitive. A prefix always wins outright.
 *
 * Shared rather than module-local (MPN-1575): the Content Catalog searches its tree with this
 * and the Moti Store searches a collection page with it, and a client typing the same letters
 * in the two places should not get two different answers.
 */
export function fuzzyMatch(value: string, query: string): boolean {
    const normalizedValue = (value || "").trim().toLowerCase();
    const normalizedQuery = (query || "").trim().toLowerCase();
    if (!normalizedQuery) return true;
    if (!normalizedValue) return false;
    if (normalizedValue.startsWith(normalizedQuery)) return true;

    let i = 0;
    for (const char of normalizedValue) {
        if (char === normalizedQuery[i]) i += 1;
        if (i === normalizedQuery.length) return true;
    }
    return false;
}
